import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-image-select-question',
  templateUrl: './image-select-question.component.html',
  styleUrls: ['./image-select-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class ImageSelectQuestionComponent implements OnInit, OnDestroy {
  value: string = null;
  error: string;
  showHelp = false;
  asyncInProgress: boolean = false;
  dispose$ = new Subject();

  @Input() question: QQQuestionViewModel;
  @Input() showHeader: boolean = false;

  @ViewChild('tipDiv') tipDiv: HTMLDivElement;

  constructor() {
  }

  ngOnInit() {
    this.value = this.question.answer;
    this.question.beforeSubmit(
      this.dispose$,
      e => {
        if (this.question.answer != this.value)
          e.add(() => this.question.setAnswer(this.value, true));
      });
  }

  ngOnDestroy(): void {
    this.dispose$.next(null);
  }

  showImage(opt: QuickQuoteOption, selected: boolean) {
    let img = opt.Image;
    if (selected)
      img = img.replace('.', '-hover.');
    return `${environment.imageBase}/assets/quickquote/${img}`;
  }

  async select(option: QuickQuoteOption) {
    this.asyncInProgress = true;
    this.question.error = null;
    this.value = option.Value;
    if (!await this.question.setAnswer(option.Value, true))
      this.value = null;
    this.asyncInProgress = false;
  }

  async autoFilled() {
    await this.question.setAnswer(this.value, true);
  }
}

type QuickQuoteOption = { Value: string, Image: string, Label: string };
